import { useQuery } from "@tanstack/react-query";
import { getEntityAchievements } from "../services/achievements.service";
import { entityKeys } from "../queryKeys";
import { AchievementsResponse } from "../types/achievements.types";

export const useEntityAchievements = (entityId: string | null) => {
  return useQuery<AchievementsResponse, Error>({
    queryKey: entityKeys.achievements(entityId!),
    queryFn: () => getEntityAchievements(entityId!),
    enabled: !!entityId,
  });
};
